exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2q5gO{margin:5 em;text-align:center}.vryl4{color:#494949;font-size:18px;font-weight:700}._6irnb,.vryl4{font-family:Roboto,sans-serif}._6irnb{text-align:justify}._4dAId{margin:45px}.dA2Xx{margin:35px}._1ywiY{text-decoration:none;color:#000;margin:10px}", ""]);

// exports
exports.locals = {
	"root": "_2q5gO",
	"title": "vryl4",
	"message": "_6irnb",
	"browserSad": "_4dAId",
	"browser": "dA2Xx",
	"download": "_1ywiY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/NavegadorIncompatible/NavegadorIncompatible.css
// module id = 1335
// module chunks = 0 1